<template>
  <div class="side-button-section">
    <v-btn
      class="primary white--text"
      depressed
      v-if="openDetailDialog"
      @click="openDetailDialog = false"
      style="
        min-width: 42px !important;
        padding: 0px !important;
        border-radius: 0px !important;
        border:0px !important;
      "
    >
      <v-icon class="">mdi-arrow-right-bold</v-icon>
    </v-btn>
    <v-navigation-drawer
      v-model="openDetailDialog"
      right
      :clipped="true"
      app
      fixed
      mobile-breakpoint="0"
      width="400"
    >
      <div
        class="white pos-rel"
        style="height: 92vh"
      >
        <v-card-title class="pa-0">
          <slot name="title"></slot>
        </v-card-title>
        <v-card-actions class="pa-0 ">
          <slot name="action"></slot>
        </v-card-actions>
        <v-card-text
          ref="orderDetailsContainer"
          class="px-0 overflow-y-auto pt-0"
          @scroll="containerScroll"
          style="position: relative"
        >
          <slot name="content"></slot>
        </v-card-text>
        <slot name="dialog"></slot>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      items: [
        { title: "Home", icon: "mdi-view-dashboard" },
        { title: "About", icon: "mdi-forum" },
      ],
    };
  },
  computed: {
    openDetailDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    scrollToTop() {
      this.$refs.orderDetailsContainer.scrollTo({ top: 0, behavior: "smooth" });
    },
    containerScroll() {
      if (
        this.$refs.orderDetailsContainer &&
        this.$refs.orderDetailsContainer.scrollTop > 0
      ) {
        this.showScrollTopButton = true;
      } else {
        this.showScrollTopButton = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.side-button-section {
  position: absolute;
  top: 0;
  right: 0;
}
</style>